import React from "react"
import { FaExclamationTriangle, FaInfoCircle, FaTimes } from "react-icons/fa"

interface iInputFeedback {
  title?: string
  value: any
  show?: boolean
  warning?: string | null
  error?: string | null
  info?: string | null
}

const ValueFeedbackCard: React.FC<{ title?: string; value: any }> = ({
  title,
  value,
}) => {
  if (!value) return null
  return (
    <div className="rounded shadow text-blue-800 hidden sm:block">
      <p
        className="rounded rounded-b-none font-bold text-center
                    text-xs lg:text-sm tracking-wide text-blue-100
                    uppercase px-4 bg-blue-700 leading-none py-1"
      >
        {title}
      </p>
      <p className="text-center font-thin text-2xl text-blue-900 px-4 pt-1 pb-1">
        {value}
      </p>
    </div>
  )
}

const FeedbackText: React.FC<{ children: any; bgColor: string }> = ({
  children,
  bgColor,
}) => (
  <p
    className={`ml-4 px-2 py-1 ${bgColor} flex items-start rounded text-white text-sm`}
  >
    {children}
  </p>
)

const WarningText: React.FC<{ show: boolean; text: string }> = ({
  show,
  text,
}) => {
  if (!show) return null
  return (
    <div>
      <FeedbackText bgColor="bg-yellow-500">
        <span className="text-red-900">
          <FaExclamationTriangle className="mr-2 mt-1 block" />
        </span>
        <span className="text-red-900 leading-4 py-1">{text}</span>
      </FeedbackText>
    </div>
  )
}

const ErrorText: React.FC<{ show: boolean; text: string }> = ({
  show,
  text,
}) => {
  if (!show) return null
  return (
    <div>
      <FeedbackText bgColor="bg-red-600">
        <span>
          <FaTimes className="mr-2 mt-1 block" />
        </span>
        <span className="leading-4 py-1">{text}</span>
      </FeedbackText>
    </div>
  )
}

const InfoText: React.FC<{ show: boolean; text: string }> = ({
  show,
  text,
}) => {
  if (!show) return null
  return (
    <div>
      <FeedbackText bgColor="bg-gray-700">
        <span className="text-white">
          <FaInfoCircle className="mr-2 mt-1 block" />
        </span>
        <span className="text-white leading-4 py-1">{text}</span>
      </FeedbackText>
    </div>
  )
}

const InputFeedback: React.FC<iInputFeedback> = ({
  title,
  value,
  show,
  warning,
  error,
  info,
}) => {
  if (!show) return null
  if (error) return <ErrorText show={Boolean(error)} text={error} />
  if (warning) return <WarningText show={Boolean(warning)} text={warning} />
  if (info) return <InfoText show={Boolean(info)} text={info} />
  return <ValueFeedbackCard title={title} value={value} />
}

export default InputFeedback
